import { AppCategories } from "./AppCategories";

export default AppCategories;
